module.exports = __webpack_public_path__ + "static/img/pro8_tab1.2423ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro8_tab1.jpg
// module id = 2tUX
// module chunks = 171